import { render, staticRenderFns } from "./EmailSetting.vue?vue&type=template&id=8f46daee"
import script from "./EmailSetting.vue?vue&type=script&lang=js"
export * from "./EmailSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports